export interface OrganisationRelationship {
  id: number;
  active: boolean;
  start_date: string;
  end_date: string;
  access_status: OrganisationAccessStatus;
  association_type: OrganisationAssociationType;
  restaurant: OrganisationRestaurant;
  tags: Array<{
    key: string;
    values: Array<string>;
  }>;
}

interface OrganisationRestaurant {
  external_id?: string;
  stripe_payouts_enabled: boolean;
  tags: Array<{
    key: string;
    value: string;
  }>;
  stripe_status: number;
  id: number;
  name: string;
}

export enum OrganisationAccessStatus {
  /** The relationship is available always. */
  always = 0,
  /** The relationship is starting soon. */
  starting = 1,
  /** The relationship is in progress and has an expiration date. */
  in_progress = 2,
  /** The relationship has expired. */
  expired = 4,
}

export enum OrganisationAssociationType {
  /** The relationship is with the first party. */
  first_party = 0,
  /** The relationship is with the third party. */
  third_party = 1,
}
